import { render, staticRenderFns } from "./materialFlow.vue?vue&type=template&id=f3c98b3e&scoped=true"
import script from "./materialFlow.vue?vue&type=script&lang=js"
export * from "./materialFlow.vue?vue&type=script&lang=js"
import style0 from "./materialFlow.vue?vue&type=style&index=0&id=f3c98b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c98b3e",
  null
  
)

export default component.exports